module.exports = __webpack_public_path__ + "img/Maattekening dubbelwerkende cilinder met Gaffel.dc0aaf8a.jpg";